var internationalPartners = {
  aliexpress: {
    color: '#FF2751',
    logo: 'https://wx.mlcdn.com.br/site/shared/icons/AliExpress.svg'
  }
};
export default internationalPartners;